(() => {
  const updateCartCount = (value) => {
    const count = Number(value);
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('[data-ci-cart-action]').forEach((action) => {
      const badge = action.querySelector('[data-ci-cart-count]');
      if (!badge) return;
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = count === 0;
      action.setAttribute('aria-label', count > 0 ? `Cart, ${count} item${count === 1 ? '' : 's'}` : 'Cart');
    });
  };

  // Cart mutations publish their total quantity when the request completes.
  document.addEventListener('shopify:cart:lines-update', (event) => {
    event.promise?.then(({ cart, detail }) => {
      updateCartCount(cart?.totalQuantity ?? detail?.itemCount);
    }).catch(() => {});
  });
  document.addEventListener('shopify:cart:view', (event) => {
    updateCartCount(event.cart?.totalQuantity);
  });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const action = document.querySelector('[data-ci-cart-action]');
    if (!action) return;
    fetch(`${action.getAttribute('href')}.js`, { credentials: 'same-origin', cache: 'no-store' })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to refresh cart count');
        return response.json();
      })
      .then((cart) => updateCartCount(cart.item_count))
      .catch(() => {});
  });

  // The announcement bar and navigation are independently editable sections.
  const updateHeaderHeights = () => {
    const topBar = document.querySelector('[data-ci-top-bar]');
    const navigation = document.querySelector('[data-ci-header-root]');
    const topBarHeight = topBar?.getBoundingClientRect().height ?? 0;
    const navigationHeight = navigation?.getBoundingClientRect().height ?? 0;
    const style = document.documentElement.style;
    style.setProperty('--ci-top-bar-height', `${topBarHeight}px`);
    style.setProperty('--ci-navigation-height', `${navigationHeight}px`);
    style.setProperty('--ci-header-height', `${topBarHeight + navigationHeight}px`);
  };
  const headerResizeObserver = new ResizeObserver(updateHeaderHeights);
  const observeHeaderSections = () => {
    headerResizeObserver.disconnect();
    document.querySelectorAll('[data-ci-top-bar], [data-ci-header-root]').forEach((section) => {
      headerResizeObserver.observe(section);
    });
    updateHeaderHeights();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-ci-header-root]').forEach((header) => {
      if (header.dataset.navigationReady === 'true') return;
      const panel = header.querySelector('.ci-mobile-panel');
      const open = header.querySelector('.ci-menu-btn');
      const close = header.querySelector('.ci-mobile-close');
      if (!panel || !open || !close) return;

      header.dataset.navigationReady = 'true';

      const setOpen = (value) => {
        panel.classList.toggle('is-open', value);
        panel.inert = !value;
        panel.setAttribute('aria-hidden', String(!value));
        document.body.classList.toggle('ci-menu-open', value);
        open.setAttribute('aria-expanded', String(value));
        if (value) close.focus();
        else open.focus();
      };

      open.addEventListener('click', () => setOpen(true));
      close.addEventListener('click', () => setOpen(false));
      panel.addEventListener('click', (event) => {
        if (event.target === panel || event.target.closest('a')) setOpen(false);
      });
      header.addEventListener('keydown', (event) => {
        if (!panel.classList.contains('is-open')) return;
        if (event.key === 'Escape') setOpen(false);
        if (event.key === 'Tab') {
          const focusable = [...panel.querySelectorAll('a, button, summary')].filter((node) => node.getClientRects().length);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });
      const desktop = window.matchMedia('(min-width: 941px)');
      desktop.addEventListener('change', (event) => {
        if (event.matches && panel.classList.contains('is-open')) setOpen(false);
      });
      const current = window.location.pathname.replace(/\/$/, '') || '/';
      header.querySelectorAll('.ci-nav a, .ci-mobile-scroll a').forEach((link) => {
        const url = new URL(link.href, window.location.href);
        if (url.pathname.replace(/\/$/, '') === current && !url.hash && url.search === window.location.search) {
          link.setAttribute('aria-current', 'page');
        }
      });
    });
  };

  const initialize = () => {
    observeHeaderSections();
    init();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', (event) => {
    observeHeaderSections();
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('[data-ci-header-root]')) document.body.classList.remove('ci-menu-open');
    // Shopify removes the section after dispatching the unload event.
    requestAnimationFrame(observeHeaderSections);
  });
})();
